const tokenListenersByAudience = new Map();
export const waitAsync = (timeoutMS) => new Promise(resolve => setTimeout(resolve, timeoutMS));
const randomBetween = (min, max) => min + Math.floor(Math.random() * (max - min));
export const reconnectAfterMs = (tries) => [randomBetween(200, 500), randomBetween(1000, 3000), randomBetween(5000, 10_000)][tries - 1] ??
    10 * 60_000;
const workspaceTokenDataStorageKey = 'converse:workspace:tokenData';
const widgetTokenDataStorageKey = 'converse:widget:tokenData';
const tokenExpirationDelta = 30_000; // 30 secs
const getStorageKeyByAudience = (audience) => {
    switch (audience) {
        case 'workspace':
            return workspaceTokenDataStorageKey;
        case 'widget':
            return widgetTokenDataStorageKey;
        default:
            throw new Error('Invalid audience, expected "workspace" or "widget"');
    }
};
const parseTokenData = (tokenData) => JSON.parse(tokenData);
const notifyTokenDataSubscribers = (audience, tokenData) => {
    tokenListenersByAudience.get(audience)?.forEach(listener => listener(tokenData));
};
export const removeTokenDataFromStorage = (audience) => {
    localStorage.removeItem(getStorageKeyByAudience(audience));
    notifyTokenDataSubscribers(audience, null);
};
export const getTokenDataFromStorage = (audience) => {
    try {
        const tokenDataStr = localStorage.getItem(getStorageKeyByAudience(audience));
        if (tokenDataStr) {
            return parseTokenData(tokenDataStr);
        }
    }
    catch (error) {
        removeTokenDataFromStorage(audience);
    }
    return;
};
export const subscribeToTokenData = (audience, listener) => {
    const listeners = tokenListenersByAudience.get(audience) || new Set();
    const currentValue = getTokenDataFromStorage(audience);
    if (currentValue) {
        listener(currentValue);
    }
    listeners.add(listener);
    // Cover same-tab changes to the stored token
    tokenListenersByAudience.set(audience, listeners);
    // Cover cross-tab changes to the stored token
    const storageListener = (event) => {
        if (event.key === getStorageKeyByAudience(audience)) {
            const tokenData = event.newValue ? parseTokenData(event.newValue) : null;
            listener(tokenData);
        }
    };
    window.addEventListener('storage', storageListener);
    return () => {
        listeners.delete(listener);
        window.removeEventListener('storage', storageListener);
    };
};
export const setTokenDataToStorage = (tokenData, audience) => {
    localStorage.setItem(getStorageKeyByAudience(audience), JSON.stringify(tokenData));
    notifyTokenDataSubscribers(audience, tokenData);
};
/**
 * Checks whether accessToken is about to expire
 */
export const isTokenAboutToExpire = (tokenData) => {
    if (tokenData) {
        return tokenData.accessTokenExpiresAt - Date.now() - tokenExpirationDelta < 0;
    }
    return true;
};
export const mapRawDataToTokenData = (rawTokenData) => ({
    refreshToken: rawTokenData.refreshToken,
    accessToken: rawTokenData.accessToken,
    accessTokenExpiresAt: Date.now() + rawTokenData.expiresIn * 1000,
});
//# sourceMappingURL=utils.js.map